import { affiliate, get} from '../session/actions';

import {
    CLIENT_DETAILS_REQUEST_START,
    CLIENT_DETAILS_REQUEST_FAIL,
    CLIENT_DETAILS_REQUEST_SUCCESS,
    VBAN_DETAILS_REQUEST_START,
    VBAN_DETAILS_REQUEST_FAIL,
    VBAN_DETAILS_REQUEST_SUCCESS
} from './types'
import { getServicesErrorObj } from '../servicesDowntime/actions';
import { AffiliateDetailsAttributes } from '../../../core/types/AffiliateDetails';

export const clientDetailsRequestStart = () => ({
    type: CLIENT_DETAILS_REQUEST_START
});

export const clientDetailsRequestFail = () => ({
    type: CLIENT_DETAILS_REQUEST_FAIL
});

export const clientDetailsRequestSuccess = (payload: any) => ({
    type: CLIENT_DETAILS_REQUEST_SUCCESS,
    payload
});

export const GET_CLIENT_DETAILS_API_URL: Function = (affiliateNo: string) => (`/affiliate-portal/ClientDetails/getClientDetails?affiliateNumber=${affiliateNo}`);

export const getClientDetails = (affiliateDetails: AffiliateDetailsAttributes) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(clientDetailsRequestStart());

    dispatch(
        get(GET_CLIENT_DETAILS_API_URL(affiliateDetails?.affiliate.affiliate_Number))
    ).then((response: any) => {
        if (response && response.data) {
            dispatch(clientDetailsRequestSuccess(response.data));
            resolve(response.data);
        } else {
            dispatch(clientDetailsRequestFail());
        }
    }).catch((error: any) => {
        dispatch(clientDetailsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject(error);
    });
});

export const vbanDetailsRequestStart = () => ({
    type: VBAN_DETAILS_REQUEST_START
});

export const vbanDetailsRequestFail = () => ({
    type: VBAN_DETAILS_REQUEST_FAIL
});

export const vbanDetailsRequestSuccess = (payload: any) => ({
    type: VBAN_DETAILS_REQUEST_SUCCESS,
    payload
});

export const GET_VBAN_DETAILS_API_URL: Function = (affiliateNo: string, language: string) => (`/affiliate-portal/VbanDetails/getVbanDetail?clientId=${affiliateNo}&language=${language}`);

export const getVBANDetails = (clientId: string) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(vbanDetailsRequestStart());

    dispatch(
        get(GET_VBAN_DETAILS_API_URL(clientId,'EN-UK'))
    ).then((response: any) => {
        if (response && response.data) {
            dispatch(vbanDetailsRequestSuccess(response.data));
            resolve(response.data);
        } else {
            dispatch(vbanDetailsRequestFail());
            reject();
        }
    }).catch((error: any) => {
        dispatch(vbanDetailsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject();
    });
});

export type clientManagementAction = {
    type: string,
    payload?: any
};
